import AbstractScene from './AbstractScene.js';
import RoundedButton2 from '../prefabs/RoundedButton2.js';
import { Colors } from '../consts/Colors.js';
import Popup from '../prefabs/Popup.js';
import PopupFin from '../prefabs/PopupFin.js';
import Deck1 from '../prefabs/game1/Deck1.js';
import Zone1 from '../prefabs/game1/Zone1.js';
import { TextContents, CartesInfos, ZonesInfos } from '../consts/DataGame1';
import { tags } from '../consts/Tags.js';

export default class Game1 extends AbstractScene {
    constructor() {
        super({
            key: "Game1"
        })
    }
    init(data) {
        this._init(data);
        this.zonesInfos = ZonesInfos;
        this.cameras.main.setBackgroundColor(Colors.Text.Beige);
        console.log(this)
    }

    preload() {
        this._preload();
    }

    create() {
        CartesInfos.sort(() => Math.random() - 0.5);
        // Ajout elements du fond
        let titre = this.add.rexTagText(715, 60, "TRÉSORERIE NETTE", {
            fontSize: '72px',
            fontFamily: 'MassiliaMedium',
            fontStyle: 'bold',
            color: Colors.Text.Blue,
            backgroundColor: 'transparent',
            align: "center",
            tags: tags
        }).setOrigin(0.5, 0)
        console.log(titre)
        let sousTitre = this.add.rexTagText(titre.x, titre.y + titre.height + 8, "Capacité à financer ses activités courantes", {
            fontSize: '32px',
            fontFamily: 'MassiliaMedium',
            fontStyle: 'bold',
            color: Colors.Text.Blue,
            backgroundColor: 'transparent',
            align: "center",
            tags: tags
        }).setOrigin(0.5, 0)
        sousTitre.setVisible(false) 
        let icon_egal = this.add.image(titre.x, sousTitre.y + sousTitre.height + 8, "icon_cercle_egale").setOrigin(0.5, 0)

        // Ajout element interactifs
        this.addDropZone()

        let icon_bleu = this.add.image(787,560, "icon_cercle_moins_bleu").setOrigin(0.5)
        let ouText = this.add.rexTagText(titre.x, 885, "ou", {
            fontSize: '32px',
            fontFamily: 'MassiliaMediumOblique',
            color: Colors.Text.Blue,
            backgroundColor: 'transparent',
            align: "center",
            tags: tags
        }).setOrigin(0.5, 0)
        let icon_orange = this.add.image(716, 984, "icon_cercle_moins_orange")
        icon_orange.setDepth(1)

        // Ajout element deco des zones
        let X = 1480
        this.transitionRect = this.add.rectangle(X, 0, this.width - X, this.height, Colors.Elmt.DarkBlue, 1).setOrigin(0, 0)
        this.deck1 = new Deck1(this, 1700, 540, 336, 490);
        this.deck1.setDepth(10)
        this.deck1.setDeckAction(CartesInfos[0])
        this.launchPopup();
        // this.endGame()
    }
    launchPopup() {
        this.popup = new Popup(this, TextContents.popup.text, 756, true);
        this.popup.introBtn.setClickFunction(() => {
            this.popup.destroy();
            this.zones.getChildren().forEach(zone => {
                zone.setActive();
            });
        })
    }

    launchEndPopup() {
        this.popup = new PopupFin(this, TextContents.popupFin.text, 756);
        this.popup.introBtn.setClickFunction(() => {
            this.transitionOut()

        })
    }


    addDropZone() {
        this.zones = this.add.group();
        this.zonesInfos.forEach( zoneInfo => {
            let newZone = new Zone1(this, zoneInfo)
            this.zones.add(newZone)
        })
    }


    transitionOut() {
        this.tweens.add({
            targets: this.deck1,
            duration: 500,
            alpha: 0,
            onComplete: () => {
                this.transitionRect.setDepth(12)
                this.tweens.add({
                    targets: this.transitionRect,
                    x: 0,
                    duration: 500,
                    onUpdate: () => {
                        this.transitionRect.width = 1920 - this.transitionRect.x;
                        // this.transitionRect.x = 1904 - this.transitionRect.width
                    },
                    onComplete: () => {
                        this.nextScene()
                    }
                })

            }
        })

    }

}